import React from 'react'
import { graphql } from 'gatsby'
import { Container } from 'theme-ui'
import Layout from '@solid-ui-layout/Layout'
import Seo from '@solid-ui-components/Seo'
import Divider from '@solid-ui-components/Divider'
import ModalWithTabs from '../../../src/@elegantstack/solid-ui-blocks/src/Modal/Block01'
import AdvertisementModal from '../../AdvertisementModal'
import Header from '../../../src/@elegantstack/solid-ui-blocks/src/Header/Block01'
import ContentOne from '@solid-ui-blocks/Content/Block01'
import Footer from '../../../src/@elegantstack/solid-ui-blocks/src/Footer/Block01'
import { normalizeBlockContentNodes } from '@blocks-helpers'

const DataProtection = props => {
  const { allBlockContent } = props.data
  const content = normalizeBlockContentNodes(allBlockContent?.nodes)

  return (
    <Layout {...props}>
      <Seo title='Home' />
      {/* Modals */}
      <ModalWithTabs content={content['authentication']} reverse />
      <ModalWithTabs content={content['contact']} />
      <AdvertisementModal />
      {/* Blocks */}
      <Header content={content['header']} />
      <Divider space='6' />
      {/* <Hero content={content['hero']} reverse /> */}
      {/* <Divider space='4' /> */}
      <Container variant="narrow">
        <ContentOne content={content['content-one']} />
      </Container>
      {/* <Divider space='5' /> */}
      {/* <Divider space='5' /> */}
      {/* <ContentTwo content={content['services']} /> */}
      {/* <Divider space='5' /> */}
      {/* <Divider space='5' /> */}
      {/* <Team content={content['team']} /> */}
      {/* <Divider space='5' /> */}
      <Footer content={content['footer']} />
    </Layout>
  )
}

export const query = graphql`
  query dataProtectionBlockContent {
    allBlockContent(
      filter: { page: { in: ["innerpage/data-protection", "shared"] } }
    ) {
      nodes {
        ...BlockContent
      }
    }
  }
`

export default DataProtection
